function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9941 0.00292969C5.48014 0.00292969 0.994141 4.48893 0.994141 10.0029C0.994141 15.5159 5.48014 20.0029 10.9941 20.0029C16.5081 20.0029 20.9941 15.5159 20.9941 10.0029C20.9941 4.48893 16.5081 0.00292969 10.9941 0.00292969ZM7.99414 15.0029V6.00293L16.9941 10.5029L7.99414 15.0029Z",
  fill: "#003056"
});

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.76e11c80.svg";
export { ForwardRef as ReactComponent };